var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightCircleUser = function SvgLightCircleUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.4 12a8.4 8.4 0 1 0-13.912 6.337L7.8 14.4h8.4l1.313 3.937A8.38 8.38 0 0 0 20.4 12m-3.9 7.095L15.334 15.6H8.663L7.5 19.095A8.4 8.4 0 0 0 12 20.4a8.36 8.36 0 0 0 4.527-1.324zM2.4 12a9.6 9.6 0 1 1 19.2 0 9.6 9.6 0 0 1-19.2 0m7.8-1.8a1.8 1.8 0 1 0 3.6 0 1.8 1.8 0 0 0-3.6 0m1.8 3a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
  })));
};
export default SvgLightCircleUser;